import { Path } from '@neo.tax/shared';
import { SredPathLoader, SredProjectsLoader } from '@neo.tax/sred/organisms';

import { useSredProjectsRedirect } from './hooks';

export const SredProjects = (): React.ReactElement => (
  <SredPathLoader path={Path.SRED_PROJECTS} useRedirect={useSredProjectsRedirect}>
    <SredProjectsLoader />
  </SredPathLoader>
);
